jQuery(function ($) {
	/**
	 * PandoraQuickSwatch Class
	 *
	 * Handles initialization of WooCommerce variation forms and radio button swatches
	 * for quick view and dynamically loaded product content.
	 *
	 * Usage:
	 *   PandoraQuickSwatch.init();                    // Initialize all on page
	 *   PandoraQuickSwatch.init($container);          // Initialize within specific container
	 *   PandoraQuickSwatch.initVariations($container); // Only initialize variations
	 *   PandoraQuickSwatch.initSwatches($container);  // Only initialize swatches
	 */
	class PandoraQuickSwatch {
		/**
		 * Initialize both variations and swatches within a container
		 *
		 * @param {jQuery|string|undefined} container - jQuery object, selector string, or undefined for document
		 */
		static _globalHandlersBound = false;

		static init(container) {
			const $container = this._getContainer(container);

			// Initialize WooCommerce variations
			this.initVariations($container);

			// Initialize radio button swatches
			this.initSwatches($container);

			// Bind document-level handlers only once
			if (!this._globalHandlersBound) {
				this._globalHandlersBound = true;

				// on click on input of pandora-variation-radio-container
				$(document.body).on(
					'change',
					'.pandora-variation-radio-container input',
					this.SelectedState.bind(this)
				);

				// check for vice-versa event
				$(document.body).on(
					'change',
					'.variations_form select',
					this.ViceVersaChange.bind(this)
				);

				// Handle label clicks - labels with for="" may target wrong element if duplicate IDs exist
				$(document.body).on(
					'click',
					'.pandora-variation-radio-item label',
					function (e) {
						e.preventDefault();
						const $radio = $(this).siblings('input[type="radio"]');
						if ($radio.length && !$radio.prop('disabled')) {
							$radio.prop('checked', true).trigger('change');
						}
					}
				);
			}
		}

		static ViceVersaChange(e) {
			// if this is checked, add class active to it's immediate parent
			const $select = $(e.target);
			console.log($select.val());

			// find the sibling of this select with class pandora-variation-radio-container
			const $radioContainer = $select.siblings('.pandora-variation-radio-container');

			// removed checked from all inputs and also active class in this container
			$radioContainer.find('input[type="radio"]').prop('checked', false);
			$radioContainer.find('.pandora-variation-radio-item').removeClass('active');

			// find the input with value that matches the value of this select
			const $input = $radioContainer.find('input[value="' + $select.val() + '"]');
			// re-check the matching radio and add class active to it's immediate parent
			$input.prop('checked', true);
			$input.closest('.pandora-variation-radio-item').addClass('active');
		}

		static SelectedState(e) {
			// if this is checked, add class active to it's immediate parent
			const $input = $(e.target);
			if ($input.is(':checked')) {
				$input
					.closest('.pandora-variation-radio-container')
					.find('.pandora-variation-radio-item')
					.removeClass('active');
				$input
					.closest('.pandora-variation-radio-item')
					.addClass('active');
			}
		}

		/**
		 * Initialize WooCommerce variation forms
		 *
		 * @param {jQuery|string|undefined} container - jQuery object, selector string, or undefined for document
		 */
		static initVariations(container) {
			const $container = this._getContainer(container);

			$container.find('.variations_form').each(function () {
				const $form = $(this);

				// Remove any existing variation form instances to prevent conflicts
				if ($form.data('wc-variation-form')) {
					try {
						$form.data('wc-variation-form').destroy();
					} catch (e) {
						console.log(
							'Error destroying existing variation form:',
							e
						);
					}
				}

				// Ensure WooCommerce variation script is available
				if (typeof $.fn.wc_variation_form !== 'undefined') {
					// Initialize WooCommerce variation form
					$form.wc_variation_form();

					// Trigger variation check to update form state
					$form.trigger('check_variations');
					$form.trigger('woocommerce_variation_has_changed');
				} else {
					console.warn(
						'WooCommerce variation form script not loaded'
					);
				}
			});
		}

		/**
		 * Initialize radio button swatches for linked attributes
		 *
		 * @param {jQuery|string|undefined} container - jQuery object, selector string, or undefined for document
		 */
		static initSwatches(container) {
			const $container = this._getContainer(container);

			// Remove existing event handlers to prevent duplicates
			$container
				.find('.pandora-variation-radio-container input[type="radio"]')
				.off('change.quickSwatch');

			// Attach event handlers with namespace
			$container
				.find('.pandora-variation-radio-container')
				.each(function () {
					const $swatchContainer = $(this);
					const parentData = $swatchContainer.data();
					const attribute = parentData.linkedattribute;

					if (!attribute) {
						console.warn(
							'PandoraQuickSwatch: linkedattribute not found on container'
						);
						return;
					}

					// Find the variation form to get attribute combinations
					const $form = $swatchContainer.closest('.variations_form');

					// Get variation data for THIS specific form (important for WooSB bundles)
					const variationData = PandoraQuickSwatch._getVariationDataFromForm($form);

					// Process each radio button
					$swatchContainer
						.find('input[type="radio"]')
						.each(function () {
							const $radio = $(this);
							const value = $radio.val();

							// Check if this attribute value leads to out-of-stock combinations
							const isOutOfStock =
								PandoraQuickSwatch._isAttributeValueOutOfStock(
									$form,
									attribute,
									value,
									variationData
								);

							if (isOutOfStock) {
								$radio.prop('disabled', true);
								$radio.addClass('out-of-stock-disabled');
								$radio
									.closest('.pandora-variation-radio-item')
									.addClass('out-of-stock-disabled');
							} else {
								$radio.prop('disabled', false);
								$radio.removeClass('out-of-stock-disabled');
								$radio
									.closest('.pandora-variation-radio-item')
									.removeClass('out-of-stock-disabled');

								// Attach change event handler for enabled radios
								$radio.on('change.quickSwatch', function () {
									const $this = $(this);
									const val = $this.val();
									const $sel = $swatchContainer.siblings(
										'select[name="' + attribute + '"]'
									);
									if ($sel.length) {
										$sel.val(val).trigger('change');
									} else {
										console.warn(
											'PandoraQuickSwatch: Select dropdown not found for attribute:',
											attribute
										);
									}
								});
							}
						});

					// Listen for changes in other attribute selects to update disabled states dynamically
					const updateSwatchStates = function () {
						// Get variation data from THIS form specifically (for WooSB bundle support)
						const currentVariationData =
							PandoraQuickSwatch._getVariationDataFromForm($form);

						$swatchContainer
							.find('input[type="radio"]')
							.each(function () {
								const $radio = $(this);
								const value = $radio.val();

								const isOutOfStock =
									PandoraQuickSwatch._isAttributeValueOutOfStock(
										$form,
										attribute,
										value,
										currentVariationData
									);

								if (isOutOfStock) {
									$radio.prop('disabled', true);
									$radio.addClass('out-of-stock-disabled');
									$radio
										.closest(
											'.pandora-variation-radio-item'
										)
										.addClass('out-of-stock-disabled');
									// Remove event handler if disabled
									$radio.off('change.quickSwatch');
								} else {
									$radio.prop('disabled', false);
									$radio.removeClass('out-of-stock-disabled');
									$radio
										.closest(
											'.pandora-variation-radio-item'
										)
										.removeClass('out-of-stock-disabled');
									// Reattach event handler if enabled and not already attached
									if (
										!$radio.hasClass(
											'quickSwatchHandlerAttached'
										)
									) {
										$radio.addClass(
											'quickSwatchHandlerAttached'
										);
										$radio.on(
											'change.quickSwatch',
											function () {
												const $this = $(this);
												const val = $this.val();
												const $sel =
													$swatchContainer.siblings(
														'select[name="' +
														attribute +
														'"]'
													);
												if ($sel.length) {
													$sel.val(val);
													$sel.trigger('change');
												}
											}
										);
									}
								}
							});
					};

					// Listen to other attribute selects changing
					$form
						.find('select[name^="attribute_"]')
						.not('select[name="' + attribute + '"]')
						.on('change.updateSwatches', updateSwatchStates);
				});
		}

		/**
		 * Get variation data from the form
		 *
		 * @param {jQuery} $container
		 * @returns {Array|null}
		 * @private
		 */
		static _getVariationData($container) {
			const $form = $container.find('.variations_form').first();
			return this._getVariationDataFromForm($form);
		}

		/**
		 * Get variation data from a specific form element
		 * (Used for WooSB bundles where each bundled product has its own form)
		 *
		 * @param {jQuery} $form
		 * @returns {Array|null}
		 * @private
		 */
		static _getVariationDataFromForm($form) {
			if (!$form || !$form.length) {
				return null;
			}

			const variationsAttr = $form.attr('data-product_variations');

			if (!variationsAttr) {
				return null;
			}

			try {
				return JSON.parse(variationsAttr);
			} catch (e) {
				console.warn(
					'PandoraQuickSwatch: Error parsing variation data:',
					e
				);
				return null;
			}
		}

		/**
		 * Check if an attribute value leads to only out-of-stock variations
		 *
		 * @param {jQuery} $form
		 * @param {string} attribute
		 * @param {string} value
		 * @param {Array|null} variationData
		 * @returns {boolean}
		 * @private
		 */
		static _isAttributeValueOutOfStock(
			$form,
			attribute,
			value,
			variationData
		) {
			if (
				!variationData ||
				!Array.isArray(variationData) ||
				variationData.length === 0
			) {
				return false;
			}

			// if value is not in the variationData, return false
			if (!variationData.find(variation => variation.attributes[attribute] === value)) {
				return true;
			}

			// Get all other selected attributes to check combinations
			const otherAttributes = {};
			$form.find('select[name^="attribute_"]').each(function () {
				const $select = $(this);
				const attrName = $select.attr('name');
				const selectedValue = $select.val();

				// Skip the current attribute being checked
				if (attrName !== attribute && selectedValue) {
					otherAttributes[attrName] = selectedValue;
				}
			});

			// Check all variations that match this attribute value
			let hasInStockVariation = false;
			let hasAnyVariation = false;

			variationData.forEach(function (variation) {
				if (!variation.attributes || !variation.attributes[attribute]) {
					return;
				}

				// Check if this variation matches the attribute value being checked
				const variationAttrValue = variation.attributes[attribute];

				// Handle different formats (slug, formatted value, etc.)
				const matchesAttribute =
					variationAttrValue === value ||
					variationAttrValue.toLowerCase() === value.toLowerCase() ||
					variationAttrValue.replace(/\s+/g, '-').toLowerCase() ===
					value.toLowerCase();

				if (!matchesAttribute) {
					return;
				}

				hasAnyVariation = true;

				// Check if other attributes match (if any are selected)
				let matchesOtherAttributes = true;
				for (const otherAttrName in otherAttributes) {
					if (otherAttributes.hasOwnProperty(otherAttrName)) {
						const otherValue = otherAttributes[otherAttrName];
						const variationOtherValue =
							variation.attributes[otherAttrName];

						if (
							variationOtherValue &&
							variationOtherValue !== otherValue &&
							variationOtherValue.toLowerCase() !==
							otherValue.toLowerCase()
						) {
							matchesOtherAttributes = false;
							break;
						}
					}
				}

				if (matchesOtherAttributes) {
					// Check stock status
					if (
						variation.is_in_stock &&
						variation.is_purchasable &&
						variation.variation_is_visible
					) {
						hasInStockVariation = true;
					}
				}
			});

			// If we have variations for this attribute value but none are in stock, disable it
			if (hasAnyVariation && !hasInStockVariation) {
				return true;
			}

			// Also check dynamically when other attributes change
			return false;
		}

		/**
		 * Get container as jQuery object
		 *
		 * @param {jQuery|string|undefined} container
		 * @returns {jQuery}
		 * @private
		 */
		static _getContainer(container) {
			if (container === undefined || container === null) {
				return $(document);
			}

			if (typeof container === 'string') {
				return $(container);
			}

			if (container instanceof jQuery) {
				return container;
			}

			return $(container);
		}
	}

	// Make class globally available
	window.PandoraQuickSwatch = PandoraQuickSwatch;

	// Auto-initialize on DOM ready (for static content)
	$(document).ready(function () {
		PandoraQuickSwatch.init();
	});
});